import { getEnvVars } from "@/environments";
import { DOCAIApi } from "./DocAIService";
import HttpClient from "./HttpClient";
import type { RequestOptions } from "./types";
import { APIHosts, ApiReduxHelpers } from "./reduxHelpers";
import { FolderService } from "./FolderService";

const { apiUrl } = getEnvVars();

class FileController {
  public Get = {
    getFileById: (file_id: string, options?: RequestOptions) => {
      const fileUrl = FolderService.getHost(FolderService.ApiHost) + "/file";
      return HttpClient.get(`${fileUrl}/${file_id}`, options);
    },
    getIraiByGuidFile: (guid_file: string, options?: RequestOptions) => {
      const fileUrl = FolderService.getHost(FolderService.ApiHost) + "/file";
      const fullUrl = `${fileUrl}/${guid_file}`;
      return HttpClient.get(fullUrl, options);
    },
  };

  public Post = {
    uploadFile: (
      file: FormData,
      name_model?: string,
      options?: RequestOptions
    ) => {
      const fileUrl = DOCAIApi.getHost(DOCAIApi.ApiHost) + "/file";
      return HttpClient.post(fileUrl, file, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        ...options,
      });
    },
    deleteFile: (file_id: string, options?: RequestOptions) => {
      const fileUrl = DOCAIApi.getHost(DOCAIApi.ApiHost) + "/file";
      return HttpClient.delete(`${fileUrl}/${file_id}`, options);
    },
    viewFilePdf: (
      file_id: string,
      number_page: string,
      options?: RequestOptions
    ) => {
      const fileUrl = DOCAIApi.getHost(DOCAIApi.ApiHost) + "/file";
      return HttpClient.get(
        `${fileUrl}/file/view-pdf-page/${file_id}/${number_page}`,
        {
          responseType: "blob",
          ...options,
        }
      );
    },
  };
}

export const FileService = new FileController();
